"use client";
/*
 * Documentation:
 * PRINT_DC_Text_Toggle — https://app.subframe.com/4f62853ee923/library?component=PRINT_DC_Text_Toggle_f7165d3e-6be0-46b1-846d-bba1f44e3ca4
 */

import React from "react";
import * as SubframeUtils from "../utils";

interface Print_Dc_Text_ToggleRootProps
  extends React.HTMLAttributes<HTMLDivElement> {
  headline?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
}

const Print_Dc_Text_ToggleRoot = React.forwardRef<
  HTMLDivElement,
  Print_Dc_Text_ToggleRootProps
>(function Print_Dc_Text_ToggleRoot(
  {
    headline,
    children,
    className,
    ...otherProps
  }: Print_Dc_Text_ToggleRootProps,
  ref
) {
  return (
    <div
      className={SubframeUtils.twClassNames(
        "flex w-full flex-col items-start gap-2",
        className
      )}
      ref={ref}
      {...otherProps}
    >
      <div className="flex w-full items-center justify-between">
        {headline ? (
          <span className="grow shrink-0 basis-0 text-body-bold font-body-bold text-default-font">
            {headline}
          </span>
        ) : null}
      </div>
      {children ? (
        <div className="flex flex-col items-start gap-2">{children}</div>
      ) : null}
    </div>
  );
});

export const Print_Dc_Text_Toggle = Print_Dc_Text_ToggleRoot;
